import {
  clearFacetInSelection,
  clearRefinementsFromSelection,
  setRangeInSelection,
  setSortInSelection,
  toggleFacetValueInSelection,
} from "./model/selection";
import { draftChanged, draftDiscarded } from "./slice";
import { selectFacetDraft } from "./selectors";
import { EDIT_SOURCE, resolveCommitPolicy } from "./commitPolicy";

// Edits are thunks because a null draft reads through to URL-derived state.
const edit =
  (nextSelectionFrom) =>
  (payload, source = EDIT_SOURCE.NEVER_COMMITS) =>
  (dispatch, getState) => {
    const state = getState();

    return dispatch(
      draftChanged(nextSelectionFrom(selectFacetDraft(state), payload), {
        commit: resolveCommitPolicy(source, state),
      }),
    );
  };

const normalizeRange = (range) => {
  if (!range) {
    return;
  }

  if (Number.isFinite(range.min) && Number.isFinite(range.max)) {
    return { min: range.min, max: range.max };
  }

  if (
    Number.isFinite(range.leftIndicator) &&
    Number.isFinite(range.rightIndicator)
  ) {
    return { min: range.leftIndicator, max: range.rightIndicator };
  }
};

export const toggleFacetValue = edit(toggleFacetValueInSelection);

export const clearFacet = edit(clearFacetInSelection);

export const clearAllFacets = edit(clearRefinementsFromSelection);

export const setFacetSort = edit(setSortInSelection);

export const setFacetRange = edit((draft, { facetId, range }) =>
  setRangeInSelection(draft, facetId, normalizeRange(range)),
);

export const resetFacetDraft = () => draftDiscarded();
